// Date Helper Functions
// Functions to work with dates, especially for week-ending Saturdays

// Get the next Saturday from a given date
export const getNextSaturday = (date = new Date()) => {
    const d = new Date(date);
    const day = d.getDay();
    const daysUntilSaturday = (6 - day + 7) % 7 || 7;
    d.setDate(d.getDate() + daysUntilSaturday);
    return d;
};

// Get the previous Saturday from a given date
export const getPreviousSaturday = (date = new Date()) => {
    const d = new Date(date);
    const day = d.getDay();
    const daysSinceSaturday = (day - 6 + 7) % 7 || 7;
    d.setDate(d.getDate() - daysSinceSaturday);
    return d;
};

// Check if a date is a Saturday
// Fixed to handle date strings correctly without timezone issues
export const isSaturday = (dateString) => {
    // Parse the date string manually to avoid timezone conversion
    // Input format is "YYYY-MM-DD"
    const parts = dateString.split('-');
    if (parts.length !== 3) return false;
    
    const year = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1; // Month is 0-indexed
    const day = parseInt(parts[2]);
    
    // Create date in local timezone
    const date = new Date(year, month, day);
    
    // Check if it's Saturday (6)
    return date.getDay() === 6;
};

// Format date to YYYY-MM-DD for input fields
export const formatDateForInput = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

// Format date for display (e.g., "Oct 21, 2025")
export const formatDateForDisplay = (dateString) => {
    // Parse date string to avoid timezone issues
    const parts = dateString.split('-');
    if (parts.length !== 3) return dateString;
    
    const year = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1;
    const day = parseInt(parts[2]);
    
    const date = new Date(year, month, day);
    
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};

// Get the most recent Saturday (today if today is Saturday, otherwise previous Saturday)
export const getMostRecentSaturday = () => {
    const today = new Date();
    if (today.getDay() === 6) {
        return today;
    }
    return getPreviousSaturday(today);
};